import React, { memo } from 'react';
import { Button } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'i18n';
import { useQueryParams } from 'hooks';

interface IClearFiltersButtonProps {
  disabled?: boolean;
  count?: number;
  onClear?: () => void;
}

const useStyles = makeStyles()({
  root: {
    textTransform: 'unset',
    borderRadius: 32,
  },
});

const ClearFiltersButton: React.FC<React.PropsWithChildren<IClearFiltersButtonProps>> = (props) => {
  const { disabled, count, onClear } = props;
  const { classes } = useStyles();

  const [t] = useTranslation();
  const [, setQueryParams] = useQueryParams();

  const handleClick = () => {
    setQueryParams({});
    onClear?.();
  };

  return (
    <Button
      size="small"
      variant="contained"
      color="primary"
      classes={classes}
      disabled={disabled}
      onClick={handleClick}
    >
      {t<string>('common:general.all')} {count && `(${count})`}
    </Button>
  );
};

export default memo(ClearFiltersButton);
